import { useCallback } from 'react';
import type { HeadlineSmallOneLineProps } from './types';
import { Flex } from '@banhala/ui-kit';
import { bridge, isNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';
import type { IScreensLogging } from '../../../../api/types';
import { ViewAllButton } from '../ViewAllButton';
import { useOpenDeeplink } from '../../../../hooks';

export const HeadlineSmallOneLine = ({ header, screen }: HeadlineSmallOneLineProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const handleClickViewAllButton = useCallback(() => {
    if (isNil(header)) return;
    const { deeplink } = header.item;
    if (isNil(deeplink)) return;

    logClickViewAllButton({ logging: header.logging, screen });

    openDeeplink(deeplink);
  }, [openDeeplink, header, screen]);

  if (isNil(header)) {
    return null;
  }
  const isRoutable = header.item.deeplink !== null;

  return (
    <Flex.Row
      padding={{ top: 24, bottom: 16, left: 16, right: isRoutable ? 0 : 16 }}
    >
      <Flex.Column flex={1} gap={2}>
        <Flex.Row
          alignItems="center"
          gap={4}
          testID={`${header.logging.analytics?.LIST_ID}?VALUE=${header.item.title}`}
        >
          <HTMLText type="h5" color="content_primary">
            {header.item.title}
          </HTMLText>
        </Flex.Row>
      </Flex.Column>
      {isRoutable && (
        <Flex
          position="absolute"
          top={0}
          bottom={0}
          right={0}
          alignItems="center"
          justifyContent="center"
        >
          <Flex padding={{ vertical: 8, left: 12 }}>
            <ViewAllButton
              testID="전체보기버튼"
              onPress={handleClickViewAllButton}
              padding={{ right: 4 }}
            />
          </Flex>
        </Flex>
      )}
    </Flex.Row>
  );
};

const logClickViewAllButton = ({ logging, screen }: { logging: IScreensLogging; screen?: string }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SMALL_ONE_LINE_MORE',
    analytics: { ...logging.analytics, ...(screen != null && { SCREEN: screen }) },
    ably_only_log: logging.ably_only_log,
  });
};
